import { Link } from "react-router-dom";
import { UserAvatar } from "./UserAvatar";
import { FollowButton } from "./FollowButton";

export function UserCard({ user, onFollowToggle }) {
  const identifier = user.username || user.user_id;
  const profilePath = user.username ? `/profile/${user.username}` : "#";

  return (
    <div className="flex items-center gap-3 p-3 rounded-lg border border-border bg-card" data-testid={`user-card-${identifier}`}>
      <Link to={profilePath} className="flex items-center gap-3 flex-1 min-w-0">
        <UserAvatar user={user} size="md" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{user.username}</p>
          {user.username && <p className="text-xs text-muted-foreground truncate">@{user.username}</p>}
        </div>
      </Link>
      <FollowButton
        username={user.username}
        userId={user.user_id}
        isFollowing={user.is_following}
        isSelf={user.is_self}
        size="sm"
        onToggle={(val) => onFollowToggle?.(user.user_id, val)}
      />
    </div>
  );
}
